import React from "react";
import CustomModel from "./customModel";

function Loader(props) {
  const { loading } = props;
  return (
    <CustomModel
      className="loaderContainer"
      open={loading}
      showCloseIcon={false}
    >
      <div className="loader"></div>
    </CustomModel>
  );
}

export default Loader;
